/*
 * @version: V1.0.0
 * @Date: 2023-11-14 19:21:05
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-14 21:24:42
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\system\menu.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 查询菜单列表
export function listMenu(query) {
  return request({
    url: '/system/menu/list',
    method: 'get',
    params: query,
    headers: {
      isSaas: true
    }
  })
}

// 查询菜单详细
export function getMenu(menuId) {
  return request({
    url: '/system/menu/' + menuId,
    method: 'get',
    headers: {
      isSaas: true
    }
  })
}

// 查询菜单下拉树结构
export function treeselect(params) {
  return request({
    url: '/system/menu/listTenantMenu',
    method: 'get',
    params,
    headers: {
      isSaas: true
    }
  })
}



// 根据角色ID查询菜单下拉树结构
export function roleMenuTreeselect(roleId) {
  return request({
    url: '/system/menu/roleMenuTreeselect/' + roleId,
    method: 'get',
    headers: {
      isSaas: true
    }
  })
}
